import React, { useCallback, useMemo } from 'react';
import { useShortTurnConfig } from '../ShortTurnConfigForm';
import { buildPreviewLadder } from '../../shared/buildPreviewLadder';
import { NumberStepper } from '@/components/ui/number-stepper';
import { fieldLabelClass, fieldDescriptionClass } from '@/components/config_forms/shared/surcharge/fieldStyles';
import { cn } from '@/lib/utils';

export const ShortTurnOffsetAmountControl: React.FC = () => {
  const { shortTurnConfig, onShortTurnConfigChange, rateMultipliers } = useShortTurnConfig();

  const ladder = useMemo(() => buildPreviewLadder(rateMultipliers), [rateMultipliers]);

  const offsetAmount = shortTurnConfig.overtimeOffset ?? 1;
  const maxOffset = Math.max(1, ladder.length - 1);
  const isDisabled = ladder.length <= 1;

  const handleChange = useCallback((next: number) => {
    onShortTurnConfigChange({ overtimeOffset: next });
  }, [onShortTurnConfigChange]);

  return (
    <div className="space-y-4">
      <div className="w-full grid grid-cols-[minmax(0,1fr)_auto] gap-x-4 gap-y-1 items-center md:grid-cols-2">
        <div className="min-w-0">
          <p className={fieldLabelClass}>Overtime Offset</p>
          <p className={cn(fieldDescriptionClass, 'mt-1 hidden md:block')}>
            Number of rate ladder steps to shift upward on a short-turn shift.
          </p>
        </div>
        <div className="flex flex-col items-end md:w-full">
          <NumberStepper
            ariaLabel="Short-turn overtime offset"
            label="Short-turn overtime offset"
            value={offsetAmount}
            min={1}
            max={maxOffset}
            disabled={isDisabled}
            onChange={handleChange}
          />
        </div>
        <p className={cn(fieldDescriptionClass, 'col-span-2 md:hidden')}>
          Number of rate ladder steps to shift upward on a short-turn shift.
        </p>
      </div>

    </div>
  );
};
